import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { api } from "../api/client";

// Search the global food database (wger) and hand a picked item to the parent.
const IngredientSearch = ({ token, onPick }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const search = async (value) => {
    setQ(value);
    if (value.trim().length < 2) { setResults([]); return; }
    setLoading(true);
    try {
      const res = await api("get", `/ingredients?search=${encodeURIComponent(value.trim())}&limit=12`, null, token);
      setResults(res.data || []);
    } catch (err) {
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const pick = (ing) => {
    onPick({
      name: ing.name,
      calories: ing.energy_kcal || 0,
      protein: ing.protein || 0,
      carbs: ing.carbs || 0,
      fat: ing.fat || 0,
      portion: ing.per || "100g",
    });
    setQ("");
    setResults([]);
  };

  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <Search size={15} style={{ opacity: 0.5 }} />
        <Input
          placeholder="Szukaj w bazie produktów (np. kurczak)…"
          value={q}
          onChange={(e) => search(e.target.value)}
        />
      </div>
      {loading && <div style={{ fontSize: 12, opacity: 0.6, padding: "4px 0" }}>Szukam…</div>}
      {results.length > 0 && (
        <div style={{ maxHeight: 180, overflowY: "auto", border: "1px solid var(--border,#eee)", borderRadius: 8, marginTop: 6 }}>
          {results.map((ing) => (
            <div
              key={ing.id}
              onClick={() => pick(ing)}
              style={{ padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid var(--border,#f0f0f0)", fontSize: 13 }}
            >
              <div style={{ fontWeight: 600 }}>{ing.name}</div>
              <div style={{ opacity: 0.6, fontSize: 11 }}>
                {ing.energy_kcal ?? "?"} kcal · B {ing.protein ?? "?"} · W {ing.carbs ?? "?"} · T {ing.fat ?? "?"} /100g
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default IngredientSearch;
